import {axios} from "@/api/config";
// 查询【请填写功能名称】列表
export function listVarDate(params) {
  return axios.get(`/varDate/list`, params, true);
}


// 查询【请填写功能名称】详细
export function getVarDate(id) {
  return axios.get(`/varDate/${id}`, id, true)
}

// 删除【请填写功能名称】
export function delVarDate(id) {
  return axios.delete(`/varDate/${id}`, true)
}

